import Button from "../../../../components/ui/Button";
import { getDeclension } from "../../../../utils/tools";
import { isMobile } from "react-device-detect";

interface ModalFooterProps {
  uniqueWarehousesCount: number;
  isLoading?: boolean;
  disabled?: boolean;
}

export const ModalFooter = ({
  uniqueWarehousesCount,
  isLoading = false,
  disabled = false,
}: ModalFooterProps) => {
  return (
    <div className={`flex ${isMobile ? 'flex-col gap-4 w-full' : 'flex-row  items-center self-end'}`}>
      <span className={`link-text !font-medium ${isMobile ? 'text-right text-sm' : 'mr-[30px]'}`}>
        Получение в{" "}
        {getDeclension(uniqueWarehousesCount, [
          "магазине",
          "магазинах",
          "магазинах",
        ])}
      </span>
      <Button
        className={`${isMobile ? 'w-full h-[50px]' : 'w-[310px] h-[59px]'} !rounded-[15px]`}
        type="submit"
        style="primary"
        isLoading={isLoading}
        disabled={disabled}
      >
        Оформить заказ
      </Button>
    </div>
  );
};